import { inject, Service } from "@angular/core";
import { map, Observable } from "rxjs";

import { environment } from "../../../core/environments/environment";
import { AdaaHelper } from "../../../core/utils";
import { Constants } from "../../../shared/constants/constants";
import { Language } from "../../../shared/constants/enums";
import { UsersApiService } from "../../../shared/services/users-api-service";

export type Adaa4Dashboard = "govDashboard" | "strategyDashboard" | "internationalDashboard" | "agenticDashboard";

@Service()
export class Adaa4RedirectService {
  private readonly _usersApiService = inject(UsersApiService);

  public dashboardUrl(dashboard: Adaa4Dashboard, language: Language): string {
    const suffix = language === Language.Arabic ? "AE" : "EN";
    return environment.adaa4Dashboards[`${dashboard}${suffix}`];
  }

  public open(url: string): void {
    this._handoffUrl(url).subscribe((handoffUrl) => {
      if (!handoffUrl) return;

      // replace() instead of href so the current page is dropped from history and Back can't return to it
      window.location.replace(handoffUrl);
    });
  }

  public openInNewTab(url: string): void {
    // Opened inside the click: browsers block a popup that waits for the hashed session response
    const tab = window.open("", "_blank");
    if (!tab) return;

    tab.opener = null;

    this._handoffUrl(url).subscribe({
      next: (handoffUrl) => {
        if (!handoffUrl) {
          tab.close();
          return;
        }

        tab.location.replace(handoffUrl);
      },
      error: () => tab.close(),
    });
  }

  private _handoffUrl(url: string): Observable<string | null> {
    const sessionId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.sessionId, { type: "string" }) as string;
    const userEntityId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.user, {
      type: "prop",
      property: "entityId",
    }) as string;

    return this._usersApiService.getHashedSessionId(sessionId).pipe(
      map((res) => {
        if (res.inError) return null;

        return `${url}?entityId=${userEntityId}&sessionId=${encodeURIComponent(res.responseData)}`;
      })
    );
  }
}
